export const negateVal = (n?: number): number | undefined => (n ? -n : n);
